function initTrustpilotWidgets() {
  overallTrustpilotStars();
  headerMegaMenu();
  customRatingAndReviews();
  customReviewSectionColumn();
  // Swiper-dependent widgets. Since 10-07-2026 custom-swiper.js is lazy-loaded
  // on non-product templates, so window.Swiper may not exist yet on the first
  // DOMContentLoaded pass. Guarded so a throw can never abort the inits below;
  // the lazy loader in theme.liquid re-runs initTrustpilotWidgets on load.
  try { customReviewSectionSwiper(); } catch (e) {}
  try { customImageAndTextReviewsSwiper(); } catch (e) {}
  try { customTestimonialsSwiper(); } catch (e) {}
  customReviewLogoBlock();
  customReviewGridSection();
  pdpReviewsBlock();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTrustpilotWidgets);
} else {
  initTrustpilotWidgets();
}

// Current storefront language (Weglot). getCurrentLang() is reliable once Weglot is
// ready. We do NOT use the URL path, because default Dutch pages have no prefix and
// that would make the Worker fall back to visitor country instead of Dutch.
function poopyWgLang() {
  try {
    if (typeof Weglot !== 'undefined' && Weglot.getCurrentLang) {
      var l = (Weglot.getCurrentLang() || '').toLowerCase();
      if (l) return l;
    }
  } catch (e) {}
  return '';
}
function poopyReviewsEndpoint() {
  var lang = poopyWgLang();
  return 'https://poopy-trustpilot-reviews.poopy-1.workers.dev/' + (lang ? ('?lang=' + encodeURIComponent(lang)) : '');
}

// Re-render all Trustpilot review sections in the correct language.
// The initial $(document).ready run can fire before Weglot has resolved the language
// (which makes the Worker fall back to visitor country). So once Weglot is ready we
// re-render, and we also re-render whenever the language is switched (NL <-> EN).
// All the render functions clear their containers before rebuilding, so re-running
// them does not duplicate reviews.
function poopyRenderAllReviews() {
  try { overallTrustpilotStars(); } catch (e) {}
  try { customRatingAndReviews(); } catch (e) {}
  try { customReviewSectionColumn(); } catch (e) {}
  try { customReviewSectionSwiper(); } catch (e) {}
  try { customImageAndTextReviewsSwiper(); } catch (e) {}
  try { customTestimonialsSwiper(); } catch (e) {}
  try { customReviewLogoBlock(); } catch (e) {}
  try { customReviewGridSection(); } catch (e) {}
  try { pdpReviewsBlock(); } catch (e) {}
}
(function bindPoopyReviewLang(retries) {
  retries = retries == null ? 50 : retries;
  if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
    poopyRenderAllReviews(); // re-run now that Weglot knows the language
    if (typeof Weglot.on === 'function') {
      Weglot.on('languageChanged', function () { poopyRenderAllReviews(); });
    }
  } else if (retries > 0) {
    setTimeout(function () { bindPoopyReviewLang(retries - 1); }, 100);
  }
})();

function overallTrustpilotStars() {
async function renderTrustpilotStars() {
  const endpoint = 'https://poopy-trustpilot-ratings.poopy-1.workers.dev/';

  try {
    // fetch score
    const res = await fetch(endpoint);
    if (!res.ok) throw new Error('Failed to fetch Trustpilot data');

    const data = await res.json();
    const score = data?.score?.trustScore || 0;

    const maxStars = 5;
    const starWidth = 21; // width of one star in SVG
    const totalWidth = maxStars * starWidth;
    const fillWidth = (score / maxStars) * totalWidth;

    // base 5-star SVG with grey background
    const baseSVG = `
      <svg width="107" height="20" viewBox="0 0 107 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 0H0V20H20V0Z" fill="#E0E0E0"></path>
        <path d="M41.6666 0H21.6666V20H41.6666V0Z" fill="#E0E0E0"></path>
        <path d="M63.3334 0H43.3334V20H63.3334V0Z" fill="#E0E0E0"></path>
        <path d="M85 0H65V20H85V0Z" fill="#E0E0E0"></path>
        <path d="M106.667 0H86.6666V20H106.667V0Z" fill="#E0E0E0"></path>

        <path d="M9.99976 13.4789L13.0414 12.7081L14.3123 16.6248L9.99976 13.4789ZM16.9998 8.41642H11.6456L9.99976 3.37476L8.35392 8.41642H2.99976L7.33309 11.5414L5.68726 16.5831L10.0206 13.4581L12.6873 11.5414L16.9998 8.41642Z" fill="white"></path>
        <path d="M31.6664 13.4789L34.708 12.7081L35.9789 16.6248L31.6664 13.4789ZM38.6664 8.41642H33.3122L31.6664 3.37476L30.0205 8.41642H24.6664L28.9997 11.5414L27.3539 16.5831L31.6872 13.4581L34.3539 11.5414L38.6664 8.41642Z" fill="white"></path>
        <path d="M53.333 13.4789L56.3747 12.7081L57.6455 16.6248L53.333 13.4789ZM60.333 8.41642H54.9788L53.333 3.37476L51.6872 8.41642H46.333L50.6663 11.5414L49.0205 16.5831L53.3538 13.4581L56.0205 11.5414L60.333 8.41642Z" fill="white"></path>
        <path d="M74.9998 13.4789L78.0414 12.7081L79.3123 16.6248L74.9998 13.4789ZM81.9998 8.41642H76.6456L74.9998 3.37476L73.3539 8.41642H67.9998L72.3331 11.5414L70.6873 16.5831L75.0206 13.4581L77.6873 11.5414L81.9998 8.41642Z" fill="white"></path>
        <path d="M96.6664 13.4789L99.708 12.7081L100.979 16.6248L96.6664 13.4789ZM103.666 8.41642H98.3122L96.6664 3.37476L95.0206 8.41642H89.6664L93.9997 11.5414L92.3539 16.5831L96.6872 13.4581L99.3539 11.5414L103.666 8.41642Z" fill="white"></path>
      </svg>
    `;

    // inject into all containers dynamically
    document.querySelectorAll('.trustpilot-trustscore-stars').forEach(el => {
      el.style.position = 'relative';
      el.innerHTML = `
        <div style="position:absolute; top:0; left:0; width:${fillWidth}px; overflow:hidden;">
          ${baseSVG.replace(/#E0E0E0/g, '#219653')}
        </div>
        ${baseSVG}
      `;
    });

  } catch (err) {
    console.error('Trustpilot error:', err);
  }
}

// run the function
renderTrustpilotStars();
}

function headerMegaMenu() {
  async function renderMegaMenuTrustScore() {
    const endpoint = 'https://poopy-trustpilot-ratings.poopy-1.workers.dev/';

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch Trustpilot data');
      const data = await res.json();

      const rating = data.score?.trustScore?.toFixed(1) || '0.0';

      const megaMenuElements = document.querySelectorAll('.poopy-mega-menu__content-wrapper__card___trustpilot');
      megaMenuElements.forEach(el => {
        el.innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0872/1068/8837/files/trustpilot_logo_fb8e03f9-46d6-4eb3-9a58-37bb4636e181.png?v=1748937071" alt="trustpilot logo" width="" height="">
          <span class="museo-medium">${rating}</span>
        `;
      });

    } catch (err) {
      console.error('Error loading Trustpilot mega menu score:', err);
    }
  }

  // Run it
  renderMegaMenuTrustScore();
}

function customRatingAndReviews() {
  async function renderTrustpilotSummary() {
    const endpoint = 'https://poopy-trustpilot-ratings.poopy-1.workers.dev/';

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch data');
      const data = await res.json();

      const rating = data.score?.trustScore || 0.0;
      const totalReviews = data.numberOfReviews?.total || 0;

      // Format number with commas (1,410)
      const formattedTotal = totalReviews.toLocaleString('en-US');

      // Array of class names to update
      const classesToUpdate = [
        'poopy-homepage-banner__copy__trustpilot__text',
        'custom_review_widget__trustpilot__text',
        'poopy-image-and-text-reviews_trustpilot__text',
        'custom-mobile-menu__body__menu-reviews__text'
      ];

      // Loop through each class and update all matching elements
      classesToUpdate.forEach(className => {
        const elements = document.querySelectorAll(`.${className}`);
        elements.forEach(el => {
          el.innerHTML = `<span class="museo-medium">(${rating}/5) ${formattedTotal} reviews</span>`;
        });
      });

      // Fusion Grit popup — live score and count
      document.querySelectorAll('.fg-trustpilot__score').forEach(el => {
        el.textContent = rating.toFixed(1).replace('.', ',') + '/5';
      });
      document.querySelectorAll('.fg-trustpilot__count').forEach(el => {
        el.textContent = totalReviews.toLocaleString('nl-NL');
      });

    } catch (err) {
      console.error('Error loading Trustpilot summary:', err);
    }
  }

  // Run
  renderTrustpilotSummary();
}

function customReviewSectionColumn() {
  async function renderLatest5StarReviewsDutchStars() {
    const endpoint = poopyReviewsEndpoint();

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch reviews');
      const reviews = await res.json();

      // Only take 5-star reviews, truncate text to 250 chars, take latest 20
      const fiveStar = reviews
        .filter(r => r.stars === 5)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 10)
        .map(r => ({
          ...r,
          text: r.text.length > 250 ? r.text.slice(0, 250) + '…' : r.text
        }));

      const midpoint = Math.ceil(fiveStar.length / 2); // use fiveStar.length!
      const col1 = document.getElementById('custom-review-section__reviews__column__1');
      const col2 = document.getElementById('custom-review-section__reviews__column__2');
      if (!col1 || !col2) return; // section not on this page

      // Helper function: Dutch "x days ago"
      const rtf = new Intl.RelativeTimeFormat('nl', { numeric: 'auto' });
      function timeAgo(dateString) {
        const now = new Date();
        const reviewDate = new Date(dateString);
        const diffMs = now - reviewDate;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        if (diffDays >= 1) return rtf.format(-diffDays, 'day');
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        if (diffHours >= 1) return rtf.format(-diffHours, 'hour');
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        if (diffMinutes >= 1) return rtf.format(-diffMinutes, 'minute');
        return rtf.format(0, 'second');
      }

      const starImgUrl = 'https://cdn.shopify.com/s/files/1/0872/1068/8837/files/trustpilot_stars.png';

      fiveStar.forEach((review, index) => {
       const reviewUrl = `https://nl.trustpilot.com/reviews/${review.id}`;
        const starsHtml = `<img src="${starImgUrl}" alt="5 stars" width="100" height="20" />`;

        const html = `
          <div class="custom-review-section__reviews__column__item">
            <a class="custom-review-section__reviews__column__item__link"  href="${reviewUrl}" target="_blank" rel="noopener noreferrer"></a>
            <div class="custom-review-section__reviews__column__item__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 3C4.05 3 0 7.05 0 12V21H9V12H3C3 8.67 5.67 6 9 6V3ZM20.4 3C15.45 3 11.4 7.05 11.4 12V21H20.4V12H14.4C14.4 8.67 17.07 6 20.4 6V3Z" fill="#219653"></path>
              </svg>
            </div>
            <div class="custom-review-section__reviews__column__item__title">
              <h3 class="museo-bold">${review.title || 'Poopy'}</h3>
            </div>
            <div class="custom-review-section__reviews__column__item__rating">
              ${starsHtml}
              <span class="museo-medium">${timeAgo(review.createdAt)}</span>
            </div>
            <div class="custom-review-section__reviews__column__item__review">
              <p class="museo-light">${review.text}</p>
            </div>
            <div class="custom-review-section__reviews__column__item__name">
              <span class="museo-bold">${review.consumer?.displayName || 'Anonymous'}</span>
            </div>
          </div>
        `;

        if (index < midpoint) {
          col1.insertAdjacentHTML('beforeend', html);
        } else {
          col2.insertAdjacentHTML('beforeend', html);
        }
      });

    } catch (err) {
      console.error('Error loading Trustpilot reviews:', err);
    }
  }

  renderLatest5StarReviewsDutchStars();
}

function customReviewSectionSwiper() {
  async function renderTrustpilotSwiper() {
    const endpoint = poopyReviewsEndpoint();

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch reviews');
      const reviews = await res.json();

      const fiveStar = reviews
      .filter(r => r.stars === 5) // only filter by stars
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 10)
      .map(r => ({
        ...r,
        text: r.text.length > 250 ? r.text.slice(0, 250) + '…' : r.text
      }));

      const swiperContainer = document.getElementById('custom-review-section__reviews__swiper');
      if (!swiperContainer) return; // section not on this page
      swiperContainer.innerHTML = ''; // clear so re-runs (e.g. language change) don't duplicate

      // Dutch relative date formatter
      const rtf = new Intl.RelativeTimeFormat('nl', { numeric: 'auto' });
      function timeAgo(dateString) {
        const now = new Date();
        const reviewDate = new Date(dateString);
        const diffMs = now - reviewDate;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        if (diffDays >= 1) return rtf.format(-diffDays, 'day');
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        if (diffHours >= 1) return rtf.format(-diffHours, 'hour');
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        if (diffMinutes >= 1) return rtf.format(-diffMinutes, 'minute');
        return rtf.format(0, 'second');
      }

      const starImgUrl = 'https://cdn.shopify.com/s/files/1/0872/1068/8837/files/trustpilot_stars.png';

      fiveStar.forEach(review => {
        const slide = document.createElement('swiper-slide');
        slide.className = 'custom-review-section__reviews__column__item';
        slide.innerHTML = `
          <div class="custom-review-section__reviews__column__item__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 3C4.05 3 0 7.05 0 12V21H9V12H3C3 8.67 5.67 6 9 6V3ZM20.4 3C15.45 3 11.4 7.05 11.4 12V21H20.4V12H14.4C14.4 8.67 17.07 6 20.4 6V3Z" fill="#219653"></path>
            </svg>
          </div>
          <div class="custom-review-section__reviews__column__item__title">
            <h3 class="museo-bold">${review.title || 'Poopy'}</h3>
          </div>
          <div class="custom-review-section__reviews__column__item__rating">
            <img src="${starImgUrl}" alt="5 stars" width="100" height="20" />
            <span class="museo-medium">${timeAgo(review.createdAt)}</span>
          </div>
          <div class="custom-review-section__reviews__column__item__review">
            <p class="museo-light">${review.text}</p>
          </div>
          <div class="custom-review-section__reviews__column__item__name">
            <span class="museo-bold">${review.consumer?.displayName || 'Anonymous'}</span>
          </div>
        `;
        swiperContainer.appendChild(slide);
      });

      // Reinitialize Swiper if needed
      if (typeof Swiper !== 'undefined') {
        new Swiper('.custom-review-section__reviews__swiper', {
          pagination: { el: '.swiper-pagination', clickable: true },
          spaceBetween: 30,
          autoplay: { delay: 3000, disableOnInteraction: false },
        });
      }

    } catch (err) {
      console.error('Error loading Trustpilot reviews:', err);
    }
  }

  // Run
  renderTrustpilotSwiper();
}

function customImageAndTextReviewsSwiper() {
  async function renderTrustpilotImageTextSwiper() {
    const endpoint = poopyReviewsEndpoint();

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch reviews');
      const reviews = await res.json();

      const fiveStar = reviews
      .filter(r => r.stars === 5) // only filter by stars
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 10)
      .map(r => ({
        ...r,
        text: r.text.length > 250 ? r.text.slice(0, 250) + '…' : r.text
      }));

      const swiperContainer = document.getElementById('poopy-image-and-text-reviews_slider_swiper');
      if (!swiperContainer) return; // section not on this page
      swiperContainer.innerHTML = ''; // clear so re-runs (e.g. language change) don't duplicate
      const starImgUrl = 'https://cdn.shopify.com/s/files/1/0872/1068/8837/files/trustpilot_stars.png';

      fiveStar.forEach(review => {
        const reviewUrl = `https://nl.trustpilot.com/reviews/${review.id}`;

        const slide = document.createElement('swiper-slide');
        slide.innerHTML = `
          <div class="poopy-image-and-text-reviews_slider_slide">
            <a class="poopy-image-and-text-reviews_slider_slide_link"  href="${reviewUrl}" target="_blank" rel="noopener noreferrer"></a>
            <div class="poopy-image-and-text-reviews_slider_slide_rate">
              <img src="${starImgUrl}" alt="5 stars" width="100" height="20" />
            </div>
            <h3 class="museo-bold">${review.title || 'Poopy'}</h3>
            <p class="museo-light">${review.text}</p>
            <span class="museo-light">${review.consumer?.displayName || 'Anonymous'}</span>
          </div>
        `;
        swiperContainer.appendChild(slide);
      });

      // Initialize Swiper if needed
      if (typeof Swiper !== 'undefined') {
        new Swiper('.poopy-image-and-text-reviews_slider_swiper', {
          slidesPerView: 1.2,
          spaceBetween: 20,
          scrollbar: { hide: false },
        });
      }

    } catch (err) {
      console.error('Error loading Trustpilot reviews:', err);
    }
  }

  // Run
  renderTrustpilotImageTextSwiper();
}

function customTestimonialsSwiper() {
  async function renderTestimonials() {
    const endpoint = poopyReviewsEndpoint();

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch reviews');
      const reviews = await res.json();

      const fiveStar = reviews
      .filter(r => r.stars === 5) // only filter by stars
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 10)
      .map(r => ({
        ...r,
        text: r.text.length > 250 ? r.text.slice(0, 250) + '…' : r.text
      }));

      const swiperContainer = document.querySelector('.custom-testimonials__swiper');
      if (!swiperContainer) return; // section not on this page
      swiperContainer.innerHTML = ''; // clear so re-runs (e.g. language change) don't duplicate
      const starImgUrl = 'https://cdn.shopify.com/s/files/1/0872/1068/8837/files/trustpilot_stars.png';
      const fallbackAvatar = 'https://cdn.shopify.com/s/files/1/0872/1068/8837/files/avatar.png?';

      // Inject slides
      fiveStar.forEach(review => {
        const reviewUrl = `https://nl.trustpilot.com/reviews/${review.id}`;
        const profileImageLink = review.consumer?.links?.find(l => l.rel === 'profile-image')?.href;
        const imgUrl = profileImageLink || fallbackAvatar;
  
        const slide = document.createElement('swiper-slide');
        slide.className = 'custom-testimonials__wrapper__item';
        slide.innerHTML = `
          <a class="custom-testimonials__wrapper__item__link"  href="${reviewUrl}" target="_blank" rel="noopener noreferrer"></a>
          <div class="custom-testimonials__wrapper__item__image">
            <img src="${imgUrl}" alt="${review.consumer?.displayName || 'Anonymous'}" width="" height="">
          </div>
          <div class="custom-testimonials__wrapper__item__copy">
            <div class="custom-testimonials__wrapper__item__upper">
              <p class="museo-medium">${review.text}</p>
            </div>
            <div class="custom-testimonials__wrapper__item__lower">
              <div class="custom-testimonials__wrapper__item__lower__rate">
                <img src="${starImgUrl}" alt="5 stars" width="" height="">
              </div>
              <div class="custom-testimonials__wrapper__item__lower__name">
                <span class="museo-medium">${review.consumer?.displayName || 'Anonymous'}</span>
              </div>
            </div>
          </div>
        `;
        swiperContainer.appendChild(slide);
      });

      // Initialize Swiper with proper autoplay & loop
      if (typeof Swiper !== 'undefined') {
        new Swiper('.custom-testimonials__swiper', {
          loop: true,
          slidesPerView: 1.2,
          spaceBetween: 20,
          autoplay: {
            delay: 4000,                // 4 seconds
            disableOnInteraction: false // keeps autoplay even after user interaction
          },
        });
      }

    } catch (err) {
      console.error('Error loading Trustpilot testimonials:', err);
    }
  }

  // Run the function
  renderTestimonials();
}

function customReviewLogoBlock() {
  async function renderTrustpilotLogoBlock() {
    const endpoint = 'https://poopy-trustpilot-ratings.poopy-1.workers.dev/';

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch Trustpilot data');

      const data = await res.json();
      const score = data?.score?.trustScore || 0;

      const maxStars = 5;
      const starWidth = 21;
      const totalWidth = maxStars * starWidth;
      const fillWidth = (score / maxStars) * totalWidth;

      const baseSVG = `
        <svg width="107" height="20" viewBox="0 0 107 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 0H0V20H20V0Z" fill="#E0E0E0"></path>
          <path d="M41.6666 0H21.6666V20H41.6666V0Z" fill="#E0E0E0"></path>
          <path d="M63.3334 0H43.3334V20H63.3334V0Z" fill="#E0E0E0"></path>
          <path d="M85 0H65V20H85V0Z" fill="#E0E0E0"></path>
          <path d="M106.667 0H86.6666V20H106.667V0Z" fill="#E0E0E0"></path>

          <path d="M9.99976 13.4789L13.0414 12.7081L14.3123 16.6248L9.99976 13.4789ZM16.9998 8.41642H11.6456L9.99976 3.37476L8.35392 8.41642H2.99976L7.33309 11.5414L5.68726 16.5831L10.0206 13.4581L12.6873 11.5414L16.9998 8.41642Z" fill="white"></path>
          <path d="M31.6664 13.4789L34.708 12.7081L35.9789 16.6248L31.6664 13.4789ZM38.6664 8.41642H33.3122L31.6664 3.37476L30.0205 8.41642H24.6664L28.9997 11.5414L27.3539 16.5831L31.6872 13.4581L34.3539 11.5414L38.6664 8.41642Z" fill="white"></path>
          <path d="M53.333 13.4789L56.3747 12.7081L57.6455 16.6248L53.333 13.4789ZM60.333 8.41642H54.9788L53.333 3.37476L51.6872 8.41642H46.333L50.6663 11.5414L49.0205 16.5831L53.3538 13.4581L56.0205 11.5414L60.333 8.41642Z" fill="white"></path>
          <path d="M74.9998 13.4789L78.0414 12.7081L79.3123 16.6248L74.9998 13.4789ZM81.9998 8.41642H76.6456L74.9998 3.37476L73.3539 8.41642H67.9998L72.3331 11.5414L70.6873 16.5831L75.0206 13.4581L77.6873 11.5414L81.9998 8.41642Z" fill="white"></path>
          <path d="M96.6664 13.4789L99.708 12.7081L100.979 16.6248L96.6664 13.4789ZM103.666 8.41642H98.3122L96.6664 3.37476L95.0206 8.41642H89.6664L93.9997 11.5414L92.3539 16.5831L96.6872 13.4581L99.3539 11.5414L103.666 8.41642Z" fill="white"></path>
        </svg>
      `;

      const trustpilotBlock = document.getElementById('custom-review-logo');
      if (!trustpilotBlock) return; // safety

      const ratingContainer = trustpilotBlock.querySelector('.custom-review-logo__item__rating');

      // replace content ONLY for trustpilot block
      ratingContainer.innerHTML = `
        <div style="position:relative; width:107px; height:20px;">
          <div style="position:absolute; top:0; left:0; width:${fillWidth}px; overflow:hidden;">
            ${baseSVG.replace(/#E0E0E0/g, '#219653')}
          </div>
          ${baseSVG}
        </div>
        <span style="font-family: 'Satoshi-Black' !important;">beoordeeld op ${score.toFixed(1)}/5</span>
        <span style="font-family: 'Satoshi-Black' !important;">Click and see more</span>
      `;

    } catch (err) {
      console.error('Trustpilot logo block error:', err);
    }
  }

  renderTrustpilotLogoBlock();
}

function customReviewGridSection() {
  async function updateTrustpilotBlocks() {
    const endpoint = poopyReviewsEndpoint();

    try {
      const res = await fetch(endpoint);
      if (!res.ok) throw new Error('Failed to fetch reviews');
      const reviews = await res.json();

      const fiveStar = reviews
        .filter(r => r.stars === 5)
        .sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 10)
        .map(r => ({
          ...r,
          text: r.text.length > 1000 ? r.text.slice(0,1000) + '…' : r.text
        }));

      const rtf = new Intl.RelativeTimeFormat('nl', { numeric: 'auto' });
      function timeAgo(dateString) {
        const now = new Date();
        const reviewDate = new Date(dateString);
        const diffMs = now - reviewDate;
        const diffDays = Math.floor(diffMs/(1000*60*60*24));
        if(diffDays>=1) return rtf.format(-diffDays,'day');
        const diffHours = Math.floor(diffMs/(1000*60*60));
        if(diffHours>=1) return rtf.format(-diffHours,'hour');
        const diffMinutes = Math.floor(diffMs/(1000*60));
        if(diffMinutes>=1) return rtf.format(-diffMinutes,'minute');
        return rtf.format(0,'second');
      }

      const starImgUrl = 'https://cdn.shopify.com/s/files/1/0872/1068/8837/files/trustpilot_stars.png';

      // Target all Trustpilot blocks by ID prefix
      const trustpilotBlocks = Array.from(document.querySelectorAll('[id^="trustpilot-review"]'));

      trustpilotBlocks.forEach((block, index) => {
        const review = fiveStar[index];
        if(!review) return;

        const reviewUrl = `https://nl.trustpilot.com/reviews/${review.id}`;
        block.innerHTML = `
          <a href="${reviewUrl}" target="_blank" rel="noopener noreferrer" class="custom-review-grid__item__link"></a>
          <div class="custom-review-grid__item__logo">
            <img src="//poopy.co/cdn/shop/files/trustpilot_logo_fb8e03f9-46d6-4eb3-9a58-37bb4636e181.png?v=1748937071&width=400" alt="Trustpilot logo" width="400" height="400" loading="lazy">
          </div>
          <div class="custom-review-grid__item__title">
            <h3 class="museo-bold" style="color:#000000;">${review.title || 'Poopy'}</h3>
          </div>
          <div class="custom-review-grid__item__rating">
            <img src="${starImgUrl}" alt="5 stars" width="100" height="20">
            <span class="museo-medium">${timeAgo(review.createdAt)}</span>
          </div>
          <div class="custom-review-grid__item__review">
            <p class="museo-light">${review.text}</p>
          </div>
          <div class="custom-review-grid__item__name">
            <span class="museo-bold">${review.consumer?.displayName || 'Anonymous'}</span>
          </div>          
        `;
      });

    } catch(err) {
      console.error('Error loading Trustpilot reviews:', err);
    }
  }

  // ✅ Actually call it
  updateTrustpilotBlocks();
}

function pdpReviewsBlock() {
  async function render() {
    const reviewsEndpoint = 'https://poopy-trustpilot-reviews.poopy-1.workers.dev/';
    const ratingEndpoint = 'https://poopy-trustpilot-ratings.poopy-1.workers.dev/';

    const wrap = document.querySelector('.pdp-reviews-block .reviews-wrap');
    const ratingBar = document.querySelector('.pdp-reviews-block .review-count-bar');

    const headerFontClass = "{{ settings.global_header_font }}";
    const textFontClass = "{{ settings.global_text_font }}";

    if (!wrap || !ratingBar) return;

    // 🇳🇱 SINGLE loading state (whole block)
    const loadingHTML = `
      <div class="review-laden ${textFontClass}">
        Reviews laden...
      </div>
    `;

    ratingBar.innerHTML = loadingHTML;
    wrap.innerHTML = '';

    try {
      const [reviewsRes, ratingRes] = await Promise.all([
        fetch(reviewsEndpoint),
        fetch(ratingEndpoint)
      ]);

      if (!reviewsRes.ok) throw new Error('Failed to fetch reviews');

      const reviews = await reviewsRes.json();

      // ─────────────────────────────
      // ⭐ TRUSTPILOT DATA
      // ─────────────────────────────
      let rating = 0;
      let totalReviews = 0;

      if (ratingRes.ok) {
        const ratingData = await ratingRes.json();
        rating = ratingData.score?.trustScore || 0;
        totalReviews = ratingData.numberOfReviews?.total || 0;
      }

      const formattedTotal = totalReviews.toLocaleString('en-US');

      // ─────────────────────────────
      // ⭐ STAR BUILDER
      // ─────────────────────────────
      function buildStars(rating) {
        const rounded = Math.round(rating);

        return Array.from({ length: 5 }).map((_, i) => {
          const filled = i < rounded;
          return `
            <svg width="14" height="14" viewBox="0 0 14 14" fill="${filled ? '#219653' : '#E0E0E0'}">
              <path d="M7 1l1.75 3.55 3.92.57-2.84 2.77.67 3.91L7 9.75l-3.5 1.84.67-3.91-2.84-2.77 3.92-.57z"/>
            </svg>
          `;
        }).join('');
      }

      // ─────────────────────────────
      // ⭐ RATING BAR
      // ─────────────────────────────
      ratingBar.innerHTML = `
        <div class="rcb-left ${headerFontClass}">
          ${formattedTotal} tevreden klanten
          <span>Gebaseerd op aankopen</span>
        </div>

        <div class="rcb-right">
          ${buildStars(rating)}
        </div>
      `;

      // ─────────────────────────────
      // 🧠 FILTER REVIEWS
      // ─────────────────────────────
      const latestFiveStar = reviews
        .filter(r => r.stars === 5)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 3);

      const starSVG = `
        <svg width="13" height="13" viewBox="0 0 14 14" fill="#219653">
          <path d="M7 1l1.75 3.55 3.92.57-2.84 2.77.67 3.91L7 9.75l-3.5 1.84.67-3.91-2.84-2.77 3.92-.57z"/>
        </svg>
      `;

      function timeAgo(dateString) {
        const now = new Date();
        const d = new Date(dateString);
        const diff = now - d;

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        if (days >= 1) return `${days} dagen geleden`;

        const hours = Math.floor(diff / (1000 * 60 * 60));
        if (hours >= 1) return `${hours} uur geleden`;

        const mins = Math.floor(diff / (1000 * 60));
        if (mins >= 1) return `${mins} minuten geleden`;

        return 'zojuist';
      }

      // ─────────────────────────────
      // ⭐ REVIEWS
      // ─────────────────────────────
      latestFiveStar.forEach(review => {
        const name = review.consumer?.displayName || 'Anonymous';
        const initial = name.charAt(0).toUpperCase();
        const url = `https://nl.trustpilot.com/reviews/${review.id}`;

        const profileImageLink = review.consumer?.links?.find(
          l => l.rel === 'profile-image'
        )?.href;

        const avatarHTML = profileImageLink
          ? `<img src="${profileImageLink}" alt="${name}" />`
          : initial;

        const card = document.createElement('div');
        card.className = 'review-card';

        card.innerHTML = `
          <a href="${url}" class="review-link" target="_blank" rel="noopener noreferrer"></a>

          <div class="review-top">
            <div class="review-stars">
              ${starSVG.repeat(5)}
            </div>
            <div class="review-date ${textFontClass}">
              ${timeAgo(review.createdAt)}
            </div>
          </div>

          <div class="review-text ${textFontClass}">
            "${review.text}"
          </div>

          <div class="review-author">
            <div class="review-avatar ${headerFontClass}">
              ${avatarHTML}
            </div>
            <div>
              <div class="review-name ${headerFontClass}">${name}</div>
              <div class="review-verified ${headerFontClass}">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M2 5l2 2 4-4" stroke="#059669" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Verified Trustpilot Review
              </div>
            </div>
          </div>
        `;

        wrap.appendChild(card);
      });

    } catch (err) {
      console.error('PDP Trustpilot block error:', err);

      ratingBar.innerHTML = `
        <div class="${textFontClass}">Reviews konden niet geladen worden</div>
      `;
    }
  }

  render();
}